import * as utils from "src/store/utils";
import { setImgStyle, parseImgUrlToken } from "src/filter/modules/img";
const { setPrintArrayContent } = utils;
export const m60SizeMap = {
	// 'F 均码': "欧洲XXXL",
	// 'L/11': "欧洲M",
	// 'M/9': "欧洲S",
	// 'S/7': "欧洲XS",
	// 'XL/13': "欧洲L",
	// 'XS/5': "欧洲",
	// 'XXL/15': "欧洲XL",
	// 'XXXL': "XXL",
	// '确认尺寸F 均码': "欧洲XXXL",
	// '确认尺寸L/11': "欧洲M",
	// '确认尺寸M/9': "欧洲S",
	// '确认尺寸S/7': "欧洲XS",
	// '确认尺寸XL/13': "欧洲L",
	// '确认尺寸XS/5': "欧洲",
	// '确认尺寸XXL/15': "欧洲XL",
	// '确认尺寸XXXL': "XXL"
}
export function setInfo1(info, table1Size) {
	console.log(info, table1Size)
	if (!info || JSON.stringify(info) === JSON.stringify({})) return [];
	return {
		style: {
			fontSize: '3mm',
			flexDirection: "column",
			padding: '0 5mm'
		},
		children: [
			{
				children: [
					{
						style: {
							flexDirection: "column",
							flex: 'none',
							width: '33%',
						},
						children: [
							{
								text: '款式图:',
								textStyle: this.zoomStyle,
								borderDouble: true,
								borderNone: 'top-border-none left-border-none border-double',
								style: {
									flex: 'none',
									borderBottom: 'none',
									height: '8mm',
									width: '100%',
									fontWeight: '600',
								}
							},
							{
								render(h) {
									const imgInfo = setImgStyle(info.frontBackImg, true)
									return <div style="height: 82mm; width: 100%; margin: 0 auto;display: flex;justify-content: center;align-items: center;">
										<img style="width: 90% !important; height: 85mm !important; object-fit: contain !important" src={parseImgUrlToken(imgInfo.url)} />
									</div>
								},
								style: {
									borderBottom: 'none',
									borderTop: 'none',
									height: '85mm',
									flex: 'none',
									width: '100%',
									textAlign: 'center',
									paddingBottom: '5px',
									display: 'flex',
								}
							}
						]
					},
					{
						style: {
							flexDirection: "column",
							borderRight: '1px solid'
						},
						children: [
							{
								style: {
									height: '16mm',
									flex: 'none',
									borderTop: '1px solid',
								},
								children: [
									{
										children: [
											{
												style: {
													flex: 'none',
													height: '16mm',
													lineHeight: '12mm',
													marginRight: '1px',
													marginLeft: '1px',
													fontWeight: '600',
													paddingTop: '1px'
												},
												textStyle: this.zoomStyle,
												// borderDouble: true,
												borderNone: 'top-border-none border-none',
												text: `版型:`
											},
											{
												style: {
													height: '16mm',
													lineHeight: '12mm',
													flex: 1,
													flexDirection: "column",
												},
												children: [
													{
														style: {
															height: '16mm',
															lineHeight: '0mm',
															flex: 1,
															fontSize: '3mm',
															// width: '80%'
														},
														textStyle: this.zoomStyle,
														children: [
															{
																style: {
																	borderTop: 'none',
																	borderRight: 'none'
																},
																render() {
																	return (
																		<div>
																			<base-checkbox style={{ 'font-size': '3mm' }} label="上装:" v-model={info.pattern} multiple={true} readOnly={false} options={[
																				{
																					comment: '紧身',
																					code: '紧身'
																				},
																				{
																					comment: '合体',
																					code: '合体'
																				},
																				{
																					comment: '宽松',
																					code: '宽松'
																				},
																				{
																					comment: 'Oversize',
																					code: 'Oversize'
																				},
																			]}></base-checkbox>
																		</div>
																	)
																}
															}
														]
													},
													{
														style: {
															height: '16mm',
															lineHeight: '0mm',
															flex: 1,
															fontSize: '3mm'
															// width: '80%'
														},
														textStyle: this.zoomStyle,
														children: [
															{
																style: {
																	borderTop: 'none',
																	borderRight: 'none'
																},
																render() {
																	return (
																		<div>
																			<base-checkbox style={{ 'font-size': '3mm' }} label="下装:" v-model={info.pattern} multiple={true} readOnly={false} options={[
																				{
																					comment: '高腰',
																					code: '高腰'
																				},
																				{
																					comment: '中腰',
																					code: '中腰'
																				},
																				{
																					comment: '低腰',
																					code: '低腰'
																				},
																			]}></base-checkbox>
																		</div>
																	)
																}
															}
														]
													}
												]
											},
										]
									}
								]
							},
							{
								style: {
									flexDirection: "column",
									flex: 'none',
								},
								children: [
									...setInfoContent(info, this.zoomStyle, '确认样衣版型及工艺修改', info.confirmSamplePattern, { borderTop: '1px solid' }, '5mm', 4),
								]
							},
							{
								style: {
									flexDirection: "column",
									flex: 'none',
									width: '100%'
								},
								children: [
									...setInfoContent(info, this.zoomStyle, '风险评估', info.riskAssessment, {}, '6mm', 3)
								]
							},

							{
								style: {
									flexDirection: "column",
									flex: 'none'
								},
								children: [
									...setInfoContent(info, this.zoomStyle, '样衣面辅料及整体搭配效果确认', info.suggestion, {}, '5mm', 3, true),
								]
							},
						]
					}
				]
			},
			{
				style: {
					flexDirection: "column",
					fontSize: '3mm',
					borderBottom: '1px solid',
				},
				children: setPage1Table(info, table1Size)
				// children: [

				// ]
			}
		]
	}
}

function setPage1Table(info, table1Size) {
	const isBrandCodeSix = info.brandCode == '6'
	info.sizeCodeList = info.sizeCodeList ? info.sizeCodeList : []
	info.sizeItemList = info.sizeItemList ? info.sizeItemList : []
	let itemStyleHeight;
	if (table1Size === 25) {
		itemStyleHeight = '6mm'
	}
	else if (table1Size === 35) {
		itemStyleHeight = '4mm'
	}

	return setPrintArrayContent([
		{
			text: '部位',
			propsName: 'usedPosition',
			style: {
				height: '10mm',
				width: info.isWoollen === '15' && '14mm',
				flex: info.isWoollen === '15' && 'none',
				lineHeight: '10mm',
				borderRight: 'none',
				borderBottom: 'none'
				// textAlign: 'center'
			},
			itemStyle: {
				minHeight: itemStyleHeight,
				height: 'auto',
				width: info.isWoollen === '15' && '14mm',
				flex: info.isWoollen === '15' && 'none',
				borderRight: 'none',
				borderBottom: 'none'
				// textAlign: 'center'
			}
		},
		{
			text: '度量方法(单位:CM)',
			propsName: 'degreeMethod',
			style: {
				height: '10mm',
				lineHeight: '10mm',
				width: '65mm',
				flex: 'none',
				borderRight: 'none',
				borderBottom: 'none'
				// textAlign: 'center'
			},
			itemStyle: {
				minHeight: itemStyleHeight,
				height: 'auto',
				width: '65mm',
				flex: 'none',
				borderRight: 'none',
				borderBottom: 'none'
				// textAlign: 'center'
			}
		},
		...info.sizeCodeList.map(item => {
			return {
				render(h) {
					const has = m60SizeMap[item.sizeName];
					const isBrandSIXSizeCodeMap = {
						"XS": '欧洲XXS',
						"S": "欧洲XS",
						"M": "欧洲S",
						"L": "欧洲M",
						"XL": "欧洲L",
						"XXL": "欧洲XL",
						"XXXL": "欧洲XXL",
					}
					let brandSixSizeName
					if (item.sizeName.indexOf('纸样尺寸') > -1 || item.sizeName.indexOf('样衣尺寸') > -1) {
						brandSixSizeName = ''
					} else {
						brandSixSizeName = isBrandSIXSizeCodeMap[item.sizeName.replace(/[\u4e00-\u9fa5]/gm, '')]
					}
					return (!isBrandCodeSix ? <div>
						<p>{item.sizeName}</p>
						{has && <p>{has}</p>}
					</div> : <div style={{ 'line-height': '12px', 'text-align': 'center' }}>
						<p>{item.sizeName.replace(/[\u4e00-\u9fa5]/gm, '')}</p>
						<p>{item.sizeName.replace(/[^\u4e00-\u9fa5]/gm, '')}</p>
						{/* {brandSixSizeName && <p>{brandSixSizeName}</p>} */}
					</div>)
				},
				// text: `item.sizeName`,
				propsName: item.sizeName,
				style: {
					height: '10mm',
					textAlign: 'center',
					borderRight: 'none',
					borderBottom: 'none'
				},
				itemStyle: {
					minHeight: itemStyleHeight,
					height: 'auto',
					textAlign: 'center',
					borderRight: 'none',
					borderBottom: 'none'
				}
			}
		}),
		{
			text: '公差 +/-',
			propsName: 'increaseOrDecrease',
			style: {
				height: '10mm',
				lineHeight: '10mm',
				textAlign: 'center',
				// borderRight: 'none',
				borderBottom: 'none'

			},
			itemStyle: {
				minHeight: itemStyleHeight,
				height: 'auto',
				textAlign: 'center',
				// borderRight: 'none',
				borderBottom: 'none'
			}
		}
	], info.sizeItemList.map(item => {
		return {
			...item,
			...item.sizeMap
		}
	}), table1Size)
}

export function setInfo2(info, enumList) {
	info.detailItemList = info.detailItemList ? info.detailItemList : []
	// const enumListShow = enumToFilter(enumList)
	return {
		style: {
			fontSize: '3mm',
			flexDirection: "column",
			padding: '0 5mm',
		},
		children: [
			{
				children: [
					{
						style: {
							flexDirection: "column",
							flex: 'none',
							// width: '40%',
						},
						children: [
							{
								style: {
									flexDirection: "column",
									flex: 'none',
									// width: '40%',
								},
								style: {
									flexDirection: "column",
									marginRight: '1px',
									borderBottom: '1px solid'
								},
								children: [
									{
										text: '前幅图样：',
										textStyle: this.zoomStyle,
										borderDouble: true,
										borderNone: 'top-border-none left-border-none border-double',
										style: {
											borderBottom: 'none',
											height: '8mm',
											flex: 'none',
											width: '76mm',
											fontWeight: '600'
										}
									},
									{
										render(h, inner) {
											const selectItem = info.detailItemList.find(item => Number(item.usedPosition) === 1);
											if (selectItem) {
												return <img style='height: 98%;' src={parseImgUrlToken(selectItem.imgUrl)}></img>;
											} else {
												return <div></div>
											}
										},
										style: {
											borderBottom: 'none',
											borderTop: 'none',
											flex: '1',
											width: '76mm',
											height: '63mm',
											textAlign: 'center',
										}
									},
									{
										text: '后幅图样：',
										textStyle: this.zoomStyle,
										borderDouble: true,
										borderNone: 'top-border-none left-border-none border-double',
										style: {
											borderBottom: 'none',
											height: '8mm',
											flex: 'none',
											width: '76mm',
											fontWeight: '600'
										}
									},
									{
										render(h, inner) {
											const selectItem = info.detailItemList.find(item => Number(item.usedPosition) === 2);
											if (selectItem) {
												return <img style='height: 98%;' src={parseImgUrlToken(selectItem.imgUrl)}></img>;
											} else {
												return <div></div>
											}
										},
										style: {
											borderBottom: 'none',
											borderTop: 'none',
											flex: 'none',
											width: '76mm',
											textAlign: 'center',
											height: '63mm',
										}
									},
									{
										text: '包装方法:',
										textStyle: this.zoomStyle,
										borderDouble: true,
										borderNone: 'top-border-none left-border-none border-double',
										style: {
											borderBottom: 'none',
											height: '8mm',
											flex: 'none',
											width: '100%',
											fontWeight: '600'
										}
									},
									{
										render() {
											const selectItem = info.detailItemList.find(item => Number(item.usedPosition) === 4);
											if (selectItem) {
												return <p>{selectItem.methodRemark}</p>
											} else {
												return ''
											}
										},
										textStyle: this.zoomStyle,
										style: {
											borderTop: 'none',
											borderBottom: 'none',
											height: '12mm',
											flex: 'none',
											width: '76mm',
										}
									},
									{
										render(h, inner) {
											const selectItem = info.detailItemList.find(item => Number(item.usedPosition) === 4);
											if (selectItem) {
												return <img style='height: 98%;' src={parseImgUrlToken(selectItem.imgUrl)}></img>;
											} else {
												return <div></div>
											}
										},
										style: {
											borderBottom: 'none',
											borderTop: 'none',
											height: '44mm',
											flex: 'none',
											width: '76mm',
											textAlign: 'center',
											paddingBottom: '5px'
										}
									},
									{
										text: '唛头车缝标准：',
										textStyle: this.zoomStyle,
										borderDouble: true,
										borderNone: 'top-border-none left-border-none border-double',
										style: {
											borderBottom: 'none',
											height: '8mm',
											flex: 'none',
											width: '76mm',
											fontWeight: '600'
										}
									},
									{
										render(h, inner) {
											const selectItem = info.detailItemList.find(item => Number(item.usedPosition) === 3);
											if (selectItem) {
												return <img style='height: 98%;' src={parseImgUrlToken(selectItem.imgUrl)}></img>;
											} else {
												return <div></div>
											}
										},
										style: {
											borderBottom: 'none',
											borderTop: 'none',
											height: '57mm',
											flex: 'none',
											width: '76mm',
											textAlign: 'center',
											paddingBottom: '5px'
										}
									},
								]
							},
						]
					},
					{
						style: {
							flexDirection: "column",
							borderRight: '1px solid',
							borderBottom: '1px solid',
							borderTop: '1px solid',
						},
						children: [
							{
								style: {
									flex: 'none',
								},
								children: [
									{
										text: '样衣下单数量：',
										textStyle: this.zoomStyle,
										style: {
											borderBottom: 'none',
											height: '6mm',
											flex: 'none',
											marginRight: '2px',
											marginLeft: '1px',
											width: '90px',
											borderRight: '1px solid',
											fontWeight: '600',
											borderTop: 'none'
										}
									},
									{
										text: info.sampleQuantityDescription,
										textStyle: this.zoomStyle,
										style: {
											height: '6mm',
											color: '#000',
											flex: '1',
											borderBottom: 'none',
											borderRight: 'none',
											borderTop: 'none'
										}
									}
								]
							},
							{
								style: {
									flex: 'none',
								},
								children: [
									{
										text: '确认版颜色：',
										textStyle: this.zoomStyle,
										style: {
											flex: 'none',
											width: '90px',
											height: '6mm',
											borderBottom: 'none',
											marginRight: '2px',
											marginLeft: '1px',
											borderRight: '1px solid',
											fontWeight: '600'
										}
									},
									{
										text: info.boardColor,
										textStyle: this.zoomStyle,
										style: {
											height: '6mm',
											flex: '1',
											borderRight: 'none'
										}
									}
								]
							},
							{
								style: {
									flexDirection: "column",
									flex: 'none',
									width: '100%'
								},
								children: [
									...setInfoContent(info, this.zoomStyle, '裁剪要求', info.cuttingDescription, { borderTop: '1px solid' }, '6mm', 5)
								]
							},
							{
								style: {
									flexDirection: "column",
									flex: 'none'
								},
								children: [
									...setInfoContent(info, this.zoomStyle, '朴条&水晶条位置', info.stripCrystalLocation, {}, '5mm', 1),
								]
							},
							{
								style: {
									flexDirection: "column",
									flex: 'none',
									width: '100%',
								},
								children: [
									...setInfoContent(info, this.zoomStyle, '特殊工艺说明', info.specialProcessDescription, { borderTop: '1px solid' }, '6mm', 3),
									// {
									// 	text: '特殊工艺说明：',
									// 	textStyle: this.zoomStyle,
									// 	style: {
									// 		borderBottom: 'none',
									// 		height: '5mm',
									// 		flex: 'none',
									// 		width: '100%'
									// 	}
									// },
									// {
									// 	text: info.specialProcessDescription,
									// 	textStyle: this.zoomStyle,
									// 	style: {
									// 		borderTop: 'none',
									// 		height: '10mm',
									// 		color: '#000'
									// 	}
									// }
								]
							},
							{
								style: {
									flexDirection: "column",
									flex: 'none'
								},
								children: [
									...setInfoContent(info, this.zoomStyle, '样衣洗水效果', info.sampleWashEffect, {}, '5mm', 1),
								]
							},
							{
								style: {
									flexDirection: "column",
									flex: 'none',
									width: '100%'
								},
								children: [
									...setInfoContent(info, this.zoomStyle, '针距要求', info.needleRequire, {}, '6mm', 3),
								]
							},
							{
								style: {
									flexDirection: "column",
									flex: 'none',
									width: '100%'
								},
								children: [
									...setInfoContent(info, this.zoomStyle, '大货缝制重点及收货标准', info.qualityRequirementsDescription, { textDecoration: 'underline' }, '6mm', 18),
								]
							},
							{
								style: {
									flexDirection: "column",
									flex: 'none',
									width: '100%',
								},
								children: [
									...setInfoContent(info, this.zoomStyle, '后整要求', info.packageDescription, {}, '6mm', 3),
								]
							},
						]
					}
				]
			},
		]
	}
}
// 设置内容
function setInfoContent(info, zoomStyle, text, content, style, height, maxLen, borderBottom) {
	let arr = []
	arr.push({
		// text: `${text}:`, 
		// textStyle: zoomStyle,
		// borderDouble: true,
		// borderNone: 'right-border',
		// style: {
		// 	flex: 'none',
		// 	height: '8mm',
		// 	width: '100%',
		// 	borderLeft: 'none',
		// 	marginTop: '1px',
		// }
		children: [
			{
				style: {
					height: '8mm'
				},
				children: [
					{
						style: {
							flex: 'none',
							height: '8mm'
						},
						text: `${text}:`,
						textStyle: {
							...zoomStyle,
							...style,
							fontWeight: '600'
						},
						borderDouble: true,
						borderNone: 'border-none',
						style: {
							flex: 'none',
							height: '8mm',
							borderLeft: 'none',
							marginTop: '1px',
							borderTop: 'none',
						}
					},
					{
						style: {
							flex: '1',
							marginTop: '1px',
							height: '8mm',
							borderRight: 'none',
							borderLeft: 'none',
						}
					}
				]
			}
		]
	})
	let list = getSplitList(content || '', zoomStyle, height, maxLen, borderBottom)
	arr = [...arr, ...list]
	return arr

}


function getSplitList(str, zoomStyle, height = '6mm', maxLen, borderBottom) {
	let splitList = []
	let match = str.match(/(\n)/gi)
	let list = match && match.length ? str.split(match[0]) : str.split()
	splitList = list.map(item => {
		return {
			style: {
				flex: 'none',
				height: height,
				width: '100%',
				marginLeft: '1px',
				borderBottom: 'none'
			},
			textStyle: zoomStyle,
			text: `${item}`
		}
	})
	splitList.splice(maxLen)
	let cententList = splitList
	if (splitList.length < maxLen) {
		for (let index = splitList.length; index < maxLen; index++) {
			splitList.push(
				{
					style: {
						flex: 'none',
						height: height,
						width: '100%',
						marginLeft: '1px',
						borderBottom: 'none'
					},
					textStyle: zoomStyle,
					text: ``
				}
			)
		}
	}
	if (!borderBottom || cententList.length < maxLen) {
		splitList[splitList.length - 1].style.borderBottom = '1px solid'
	}
	return splitList
}